/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps, Placeholder, InnerBlocks, BlockControls, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, PanelRow, RangeControl } from '@wordpress/components';

import { get } from 'lodash';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */


//
// Media handling from https://samhermes.com/posts/implementing-media-controls-in-custom-blocks/
//

export default function edit(props) {
	const { className, setAttributes } = props;
	const { attributes } = props;


	const INNER_TEMPLATE = [
		[ 'museuio-companion/logo-bar-item', {} ],
		[ 'museuio-companion/logo-bar-item', {} ],
		[ 'museuio-companion/logo-bar-item', {} ],
	];

	return (
		<div { ...useBlockProps() }>

			<InspectorControls>
				<PanelBody
					title={ __('Layout', 'museuio-companion') }
					initialOpen={true}
				>
					<PanelRow>
						<RangeControl
							min={50}
							max={300}
							label={ __('Image area height', 'museuio-companion') }
							value={ attributes.image_area_height }
							onChange={(newval) => {
								setAttributes({ image_area_height: newval });
							} }
							disableAlpha
						/>
					</PanelRow>

					<PanelRow>
						<RangeControl
							min={0}
							max={300}
							label={ __('Horizontal margin between logos', 'museuio-companion') }
							value={ attributes.logo_margin }
							onChange={(newval) => {
								setAttributes({ logo_margin: newval });
							} }
							disableAlpha
						/>
					</PanelRow>

					<PanelRow>
						<RangeControl
							min={0}
							max={300}
							label={ __('Vertical margin between logos', 'museuio-companion') }
							value={ attributes.logo_margin_vertical }
							onChange={(newval) => {
								setAttributes({ logo_margin_vertical: newval });
							} }
							disableAlpha
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>
			
			<div className="mio-logo-bar--editor"
				style={{
					'--image-area-height': attributes.image_area_height + 'px', 
					'--logo-margin-horizontal': attributes.logo_margin + 'px',
					'--logo-margin-vertical': attributes.logo_margin_vertical + 'px',
					'--logo-align-horizontal': attributes.logo_align_horizontal + 'px',
				}}
				>

				<InnerBlocks
					template={ INNER_TEMPLATE }
					allowedBlocks={['museuio-companion/logo-bar-item']}
					orientation="horizontal"
					data-columns={ attributes.columns }
					renderAppender={ InnerBlocks.ButtonBlockAppender }
					templateLock="" />
			</div>

		</div>
	);
}
